import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../../components/toast/ErrorToast";
import DateAdapter from "../../../adapters/DateAdapter";
import dayjs from "dayjs";
import SaporeForm from "../../../forms/SaporeForm";
import DateField from "../../../forms/fields/DateField";

export default class ListOrdersFeature {

    constructor(application, navigator) {
        this._application = application;
        this._navigate = navigator;
        this._loaded = false;
        this._orders = [];
        this._dateRangeForm = this._createDateRangeForm();

        makeObservable(this, {
            _loaded: observable,
            _orders: observable,
            _dateRangeForm: observable,
            loaded: computed,
            orders: computed,
            dateRangeForm: computed
        })
    }

    _createDateRangeForm() {
        const fields = {
            "fromDate": new DateField(false, dayjs().subtract(1, 'day'), this),
            "toDate": new DateField(false, dayjs().add(15, 'days'), this)
        }
        return new SaporeForm(fields);
    }

    async aValueChanged() {
        await this.reload();
    }

    get dateRangeForm() {
        return this._dateRangeForm;
    }

    async load() {
        await this._getOrders()
        this.finishLoading()
    }

    async reload() {
        this._loaded = false;
        await this.load();
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get orders() {
        return this._orders;
    }

    set orders(value) {
        this._orders = value;
    }

    fromDateField() {
        return this.dateRangeForm.getFieldByName("fromDate");
    }

    toDateField() {
        return this.dateRangeForm.getFieldByName("toDate");
    }

    columns() {
        return [
            {id: 'orderNumber', label: 'Número de Pedido'},
            {id: 'purchaseOrderNumber', label: 'Número de Orden de Compra'},
            {id: 'clientFantasyName', label: 'Nombre de Fantasía'},
            {id: 'customerBusinessName', label: 'Razón Social'},
            {id: 'deliveryDate', label: 'Fecha de Entrega'},
            {id: 'deliverySite', label: 'Punto de Entrega'},
            {id: 'state', label: 'Estado'},
            {id: 'invoiceNumber', label: 'Nro. Factura'},
            {id: 'authorizationState', label: 'Estado de Autorización'},
        ];
    }

    presentedOrders() {
        return this.orders.map(order => {
            return this._presentOrder(order);
        });
    }

    _presentOrder(order) {
        const dateAdapter = new DateAdapter()
        return {
            id: order.state !== "INVOICED" ? order.orderNumber : order.invoiceNumber,
            orderNumber: order.orderNumber,
            purchaseOrderNumber: order.customersOrderNumber,
            customerBusinessName: order.customerBusinessName,
            clientFantasyName: order.customerFantasyName,
            deliveryDate: dateAdapter.adapt(order.deliveryDate),
            deliverySite: order.deliverySiteName,
            state: this.adaptOrderState(order.state),
            invoiceNumber: order.invoiceNumber,
            authorizationState: order.authorizationState,
        }
    }
    adaptOrderState(orderState) {
        if (orderState === "INITIAL") {
            return "ABIERTO"
        }
        if (orderState === "PENDING") {
            return "CERRADO"
        }
        if (orderState === "CONFIRMED") {
            return "PROCESO DE FACTURACIÓN"
        }
        if (orderState === "INVOICED") {
            return "FACTURADO"
        }
        if (orderState === "FAILED_TO_CONFIRMED") {
            return "FALLO EN TRANSMISIÓN"
        }
        if (orderState === "REVISION") {
            return "EN REVISIÓN"
        }
        if (orderState === "REJECTED") {
            return "RECHAZADO"
        }
        if (orderState === "TRANSMITTING") {
            return "TRANSMITIENDO"
        }
    }

    async _getOrders() {
        const fromDate = this.fromDateField().value;
        const toDate = this.toDateField().value;
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.orders = response.orders();
            },
            handlesError: (response) => {
                errorToast('No se pudieron obtener los pedidos')
            }
        });
        return this._application.apiClient().getOrders(responseHandler, fromDate, toDate)
    }

    orderScreenUrl(row){
        return (`/order/${row.id}`)
    }
}